export default __webpack_public_path__ + "static/media/background-edit.edb862ef.jpg";